import { z } from 'zod';
import { esquemaId, esquemaMotivo } from './comunes.js';
/**
 * Acceso excepcional de soporte (F5.6, SEC-04, plan maestro §14.3, AC-20).
 *
 * Solicitud (operador, con motivo y alcance) → autorizacion del PROPIETARIO del
 * consultorio → permiso temporal → sesion marcada como soporte, solo lectura y
 * acotada a las pacientes del alcance → cada accion registrada con el actor
 * real → expiracion o revocacion → revision. No hay suplantacion: soporte no
 * firma, no escribe y no exporta.
 */
export const DURACION_MAXIMA_DE_SOPORTE_MIN = 240;
export const MAXIMO_DE_PACIENTES_EN_SOPORTE = 20;
export const ESTADOS_DE_SOPORTE = [
    'solicitado',
    'autorizado',
    'rechazado',
    'revocado',
    /** Derivado: autorizado y ya paso su hora. */
    'expirado',
];
export const esquemaSolicitudDeSoporte = z
    .object({
    motivo: esquemaMotivo,
    /** Alcance: las pacientes concretas del caso. Nunca «todo el consultorio». */
    pacienteIds: z.array(esquemaId).min(1).max(MAXIMO_DE_PACIENTES_EN_SOPORTE),
    duracionMinutos: z.number().int().min(5).max(DURACION_MAXIMA_DE_SOPORTE_MIN),
})
    .strict();
export const esquemaDecisionDeSoporte = z
    .object({ decision: z.enum(['autorizar', 'rechazar']), motivo: esquemaMotivo })
    .strict();
export const esquemaRevocacionDeSoporte = z.object({ motivo: esquemaMotivo }).strict();
//# sourceMappingURL=soporte.js.map